module.exports = __webpack_public_path__ + "static/media/geelong-cats-football-logo.34669142.svg";